import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import {
  DatasetListItem,
  DisplayedCollection,
  User,
} from "../../app/backendTypes";
import { useState } from "react";
import { Close } from "@mui/icons-material";
import { useDatasets } from "../../app/hooks";
import DatasetsPicker from "./DatasetsPicker";
import DatasetPermissions from "./DatasetPermissions";
import Morselbar from "../common/Morselbar";

export default function DatasetsAccess(props: {
  displayedCollection: DisplayedCollection;
  user: User;
}) {
  const { displayedCollection, user } = props;

  const [open, setOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const [dataset, setDataset] = useState<DatasetListItem | null>(null);

  const { datasets, error, loading } = useDatasets(displayedCollection.id);

  return (
    <>
      <Button onClick={() => setOpen(true)} color="secondary">
        Get access to datasets
      </Button>

      <Dialog open={open} fullWidth>
        <DialogTitle>
          Datasets
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => {
              setDataset(null);
              setOpen(false);
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Items are loaded from{" "}
            <Typography component="span" color="secondary">
              {displayedCollection.info.display_name}
            </Typography>{" "}
            project
          </DialogContentText>
          <br />
          <DialogContentText variant="body2">
            It can take up to 24 hours for changes to take effect
          </DialogContentText>
          <br />
          <DatasetsPicker
            datasets={datasets}
            loading={loading}
            error={error}
            onChange={(val) => setDataset(val)}
            initialValue={dataset}
          />
          <br />
          <br />
          {dataset !== null && (
            <DatasetPermissions
              collectionId={displayedCollection.id}
              collectionName={displayedCollection.info.display_name}
              dataset={dataset}
              user={user}
              collectionKind={displayedCollection.kind}
              allowWriteAccess={displayedCollection.allow_write_access}
            />
          )}
          <br />
        </DialogContent>
      </Dialog>

      <Morselbar
        open={errorOpen}
        setOpen={setErrorOpen}
        content="Failed to load datasets"
        error={error}
      />
    </>
  );
}
